import clsx from "clsx";
import Modal from "../Modal/Modal";
import SearchContactNetwork from "../SearchContactNetwork/SearchContactNetwork";
import { useTranslation } from "react-i18next";
import { MdClose } from "react-icons/md";
import useInvites from "src/hooks/useInvites";
import SentInvitesList from "../SentInvitesList/SentInvitesList";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface ISearchNetworkModal {
  onClose: () => void;
}

const SearchNetworkModal: React.FC<ISearchNetworkModal> = ({ onClose }) => {
  const { t } = useTranslation();
  const { sentInvites, isLoadingInvites } = useInvites();

  return (
    <Modal
      onEscape={() => onClose()}
      className={clsx(["md:!max-w-[850px]", "md:!w-full"])}
    >
      <Modal.Header title="Buscar usuarios" onClose={() => onClose()} />
      <Modal.Body>
        <div className={clsx(["flex", "w-full", "gap-4", "flex-col"])}>
          <SearchContactNetwork />
          {!isLoadingInvites && sentInvites?.length > 0 && <SentInvitesList />}
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: onClose,
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
          },
        ]}
      />
    </Modal>
  );
};

export default SearchNetworkModal;
